export default __webpack_public_path__ + "static/media/case-path.6d95463d.svg";